var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6882 10.014L9.08139 4.33272C9.32015 4.02635 9.40504 3.67215 9.32546 3.31149C9.25648 2.98363 9.05486 2.67189 8.75243 2.43539L8.01493 1.84953C7.37293 1.33892 6.57706 1.39267 6.12076 1.97853L5.62732 2.61867C5.56365 2.69876 5.57957 2.81701 5.65916 2.88151C5.65916 2.88151 6.90602 3.88123 6.93255 3.90273C7.01744 3.98335 7.08111 4.09085 7.09703 4.21985C7.12356 4.47247 6.94846 4.70896 6.68848 4.74121C6.56645 4.75733 6.44972 4.71971 6.36483 4.64984L5.0543 3.60711C4.99063 3.55928 4.89512 3.56949 4.84207 3.63399L1.72757 7.66514C1.52595 7.91775 1.45697 8.24562 1.52595 8.56274L1.92388 10.2881C1.94511 10.3794 2.02469 10.4439 2.1202 10.4439L3.87111 10.4224C4.18945 10.4171 4.48658 10.2719 4.6882 10.014ZM7.13983 9.47666H9.99487C10.2734 9.47666 10.5 9.70616 10.5 9.98835C10.5 10.2711 10.2734 10.5 9.99487 10.5H7.13983C6.86127 10.5 6.63472 10.2711 6.63472 9.98835C6.63472 9.70616 6.86127 9.47666 7.13983 9.47666Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhite);
export default __webpack_public_path__ + "static/media/edit_white.70bedde07c2eba9d205dc7dfe8fd2489.svg";
export { ForwardRef as ReactComponent };